import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  getEmbedAccessToken,
  setEmbedAccessToken,
} from '../../services/api';
import EmbedMyTicketsPanel from './EmbedMyTicketsPanel';

const EMBED_TOKEN_MESSAGE = 'SUPPORT_HUB_EMBED_TOKEN';
const EMBED_READY_MESSAGE = 'SUPPORT_HUB_EMBED_READY';

const Page = styled.div`
  min-height: 100%;
  box-sizing: border-box;
`;

const Status = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  color: #636e72;
  font-size: 0.95rem;
  text-align: center;
  padding: 1rem;
`;

const EmbedUserTicketsPage = () => {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const existing = getEmbedAccessToken();
    if (existing) {
      setReady(true);
    }

    // Público: qualquer app host pode enviar o token. A proteção é o embedToken (JWT) na API.
    const onMessage = (event) => {
      const data = event.data;
      if (!data || data.type !== EMBED_TOKEN_MESSAGE || !data.token) {
        return;
      }
      setEmbedAccessToken(data.token);
      setError(null);
      setReady(true);
    };

    window.addEventListener('message', onMessage);
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: EMBED_READY_MESSAGE }, '*');
    }

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  if (error) {
    return (
      <Page>
        <Status>{error}</Status>
      </Page>
    );
  }

  if (!ready) {
    return (
      <Page>
        <Status>Aguardando sessão do app host...</Status>
      </Page>
    );
  }

  return (
    <Page>
      <EmbedMyTicketsPanel />
    </Page>
  );
};

export default EmbedUserTicketsPage;
